import tw from "twin.macro";

export const StyledTitle = tw.h1`
   text-3xl md:text-[2.75rem] md:leading-[120%] font-light uppercase
`;
